import { render, staticRenderFns } from "./ReClientNote.vue?vue&type=template&id=17e8f724&scoped=true"
import script from "./ReClientNote.vue?vue&type=script&lang=js"
export * from "./ReClientNote.vue?vue&type=script&lang=js"
import style0 from "./ReClientNote.vue?vue&type=style&index=0&id=17e8f724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e8f724",
  null
  
)

export default component.exports